<div class="containeer-fluid">
  <div class="row">
    <div class="col-11">
      <div class="row">
        <div class="d-flex align-items-center justify-content-between mb-2">
          <h5 class="d-flex align-items-center mb-0">
            <i class="fa fa-list text-primary me-2"></i>
            Asset Report > List
          </h5>
          <div>
            <app-list-header [$parent]="getSelf()"></app-list-header>
          </div>
        </div>

        <div class="col col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="row g-2 mt-1">
                <div class="d-flex align-content-center justify-content-between flex-wrap">
                  <div class="d-flex order-actions flex-wrap gap-2 align-items-end">
                    <!-- 🔹 Plant Code -->
                    <div>
                      <label for="plantCode" class="form-label mb-0">Plant Name</label>
                      <input id="plantCode" type="text" class="form-control form-control-sm"
                        placeholder="Enter Plant Name" [(ngModel)]="filters['plantCode']" required="true" />
                    </div>

                    <!-- 🔹 From Date -->
                    <div>
                      <label for="fromDate" class="form-label mb-0">From Date</label>
                      <input type="date" id="fromDate" class="form-control form-control-sm"
                        [(ngModel)]="filters['startDate']" />
                    </div>

                    <!-- 🔹 To Date -->
                    <div>
                      <label for="toDate" class="form-label mb-0">To Date</label>
                      <input type="date" id="toDate" class="form-control form-control-sm"
                        [(ngModel)]="filters['endDate']" />
                    </div>

                    <!-- 🔹 Status Dropdown -->
                    <div>
                      <label class="form-label mb-0">Status</label>
                      <select class="form-select form-select-sm" [(ngModel)]="filters['scanStatus']">
                        <option value>-- Select --</option>
                        <option value="all">All</option>
                        <option value="Scanned">Scanned</option>
                        <option value="Not Scanned">Not Scanned</option>
                        <option value="Other Asset Scan">Other Asset Scan</option>                       
                      </select>
                    </div>

                    <!-- 🔹 Action Buttons -->
                    <div class="d-flex align-items-end gap-2">
                      <button type="button" class="btn btn-sm btn-outline-primary" (click)="loadReport()" 
                        [disabled]="!filters['plantCode'] || !filters['startDate'] || isLoading">
                        <i class="fa fa-search"></i> 
                        <span *ngIf="!isLoading">Search</span>
                        <span *ngIf="isLoading">Searching...</span>
                      </button>

                      <button type="button" class="btn btn-sm btn-outline-primary"
                        (click)="resetFilters()" 
                        [disabled]="isLoading">
                        <i class="fa fa-eraser"></i> Reset
                      </button>

                      <button type="button" title="CSV" class="btn btn-sm btn-outline-primary" 
                        (click)="downloadCsv()"
                        [disabled]="!filters['plantCode'] || !filters['startDate'] || isLoading">
                        <i class="fa fa-file-excel"></i> Excel
                      </button>

                      <button type="button" title="PDF" class="btn btn-sm btn-outline-primary" 
                        (click)="downloadPdf()"
                        [disabled]="!filters['plantCode'] || !filters['startDate'] || isLoading">
                        <i class="fa fa-file-pdf"></i> PDF
                      </button>

                      <button type="button" title="Summary Report" class="btn btn-sm btn-outline-primary"
                        (click)="summaryReport()" 
                        [disabled]="!filters['plantCode'] || !filters['startDate'] || isLoading">
                        <i class="fa fa-file-pdf"></i> Summary Report
                      </button>

                      <!-- Clear Column Search Button -->
                      <button type="button" class="btn btn-sm btn-outline-primary" 
                        (click)="clearColumnSearches()"
                        [disabled]="(!colSearch.assetNumber && !colSearch.assetLocation && !colSearch.status && 
                          !colSearch.assetCurrentLocation && !colSearch.scanType && !colSearch.userName && 
                          !colSearch.readerId && !colSearch.lastScan && !colSearch.AssetDescription && !colSearch.scanned_value) || isLoading">
                        <i class="fa fa-times"></i> Clear Table Search
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body position-relative" style="padding-bottom: 70px">
              <div class="mb-2">
                <!-- Loading Indicator -->
                <div *ngIf="isLoading" class="text-center py-3">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <p class="mt-2 text-muted">Loading data...</p>
                </div>

                <div *ngIf="!isLoading" class="table-responsive">
                  <p *ngIf="form['searchError'] == false && form['searchMessage']">
                    <app-ncs-alert [message]="form['searchMessage']" type="success"></app-ncs-alert>
                  </p>

                  <p *ngIf="form['searchError'] == true && form['searchMessage']">
                    <app-ncs-alert [message]="form['searchMessage']" type="danger"></app-ncs-alert>
                  </p>

                  <!-- Search Summary -->
                  <div *ngIf="colSearch.assetNumber || colSearch.assetLocation || colSearch.status" 
                       class="alert alert-info py-2 mb-2">
                    <small>
                      <i class="fa fa-info-circle"></i>
                      Searching across all {{totalItems}} records. 
                      Showing page {{currentPage}} of {{totalPages}}
                    </small>
                  </div>

                  <table class="table table-striped mb-0">
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th (click)="sortData('assetNumber')">
                          Asset Number
                          <i *ngIf="sortColumn === 'assetNumber' && sortDirection === 'asc'" 
                             class="fa fa-sort-up ms-1"></i>
                          <i *ngIf="sortColumn === 'assetNumber' && sortDirection === 'desc'" 
                             class="fa fa-sort-down ms-1"></i>
                          <i *ngIf="sortColumn !== 'assetNumber'" class="fa fa-sort ms-1"></i>
                        </th>

                         <th (click)="sortData('AssetDescription')">
                          Asset Description
                          <i *ngIf="sortColumn === 'AssetDescription' && sortDirection === 'asc'" 
                             class="fa fa-sort-up ms-1"></i>
                          <i *ngIf="sortColumn === 'AssetDescription' && sortDirection === 'desc'" 
                             class="fa fa-sort-down ms-1"></i>
                          <i *ngIf="sortColumn !== 'AssetDescription'" class="fa fa-sort ms-1"></i>
                        </th>


                        <th (click)="sortData('assetLocation')">
                          Asset Location
                          <i *ngIf="sortColumn === 'assetLocation' && sortDirection === 'asc'" 
                             class="fa fa-sort-up ms-1"></i>
                          <i *ngIf="sortColumn === 'assetLocation' && sortDirection === 'desc'" 
                             class="fa fa-sort-down ms-1"></i>
                          <i *ngIf="sortColumn !== 'assetLocation'" class="fa fa-sort ms-1"></i>
                        </th>

                        <th (click)="sortData('assetCurrentLocation')">
                          Current Location
                          <i *ngIf="sortColumn === 'assetCurrentLocation' && sortDirection === 'asc'" 
                             class="fa fa-sort-up ms-1"></i>
                          <i *ngIf="sortColumn === 'assetCurrentLocation' && sortDirection === 'desc'" 
                             class="fa fa-sort-down ms-1"></i>
                          <i *ngIf="sortColumn !== 'assetCurrentLocation'" class="fa fa-sort ms-1"></i>
                        </th>

                        <th (click)="sortData('scanType')">
                          Scan By
                          <i *ngIf="sortColumn === 'scanType' && sortDirection === 'asc'" 
                             class="fa fa-sort-up ms-1"></i>
                          <i *ngIf="sortColumn === 'scanType' && sortDirection === 'desc'" 
                             class="fa fa-sort-down ms-1"></i>
                          <i *ngIf="sortColumn !== 'scanType'" class="fa fa-sort ms-1"></i>
                        </th>

                        <th (click)="sortData('scanned_value')">
                          Tag ID
                          <i *ngIf="sortColumn === 'scanned_value' && sortDirection === 'asc'" 
                             class="fa fa-sort-up ms-1"></i>
                          <i *ngIf="sortColumn === 'scanned_value' && sortDirection === 'desc'" 
                             class="fa fa-sort-down ms-1"></i>
                          <i *ngIf="sortColumn !== 'scanned_value'" class="fa fa-sort ms-1"></i>
                        </th>
                        
                        <th (click)="sortData('status')">
                          Status
                          <i *ngIf="sortColumn === 'status' && sortDirection === 'asc'" 
                             class="fa fa-sort-up ms-1"></i>
                          <i *ngIf="sortColumn === 'status' && sortDirection === 'desc'" 
                             class="fa fa-sort-down ms-1"></i>
                          <i *ngIf="sortColumn !== 'status'" class="fa fa-sort ms-1"></i>
                        </th>

                        <th (click)="sortData('userName')">
                          User Name
                          <i *ngIf="sortColumn === 'userName' && sortDirection === 'asc'" 
                             class="fa fa-sort-up ms-1"></i>
                          <i *ngIf="sortColumn === 'userName' && sortDirection === 'desc'" 
                             class="fa fa-sort-down ms-1"></i>
                          <i *ngIf="sortColumn !== 'userName'" class="fa fa-sort ms-1"></i>
                        </th>

                        <th (click)="sortData('readerId')">
                          Reader Id
                          <i *ngIf="sortColumn === 'readerId' && sortDirection === 'asc'" 
                             class="fa fa-sort-up ms-1"></i>
                          <i *ngIf="sortColumn === 'readerId' && sortDirection === 'desc'" 
                             class="fa fa-sort-down ms-1"></i>
                          <i *ngIf="sortColumn !== 'readerId'" class="fa fa-sort ms-1"></i>
                        </th>

                        <th (click)="sortData('lastScan')">
                          Last Scan
                          <i *ngIf="sortColumn === 'lastScan' && sortDirection === 'asc'" 
                             class="fa fa-sort-up ms-1"></i>
                          <i *ngIf="sortColumn === 'lastScan' && sortDirection === 'desc'" 
                             class="fa fa-sort-down ms-1"></i>
                          <i *ngIf="sortColumn !== 'lastScan'" class="fa fa-sort ms-1"></i>
                        </th>
                      </tr>
                      
                      <!-- Column Search Row -->
                      <tr>
                        <th></th>
                        <th>
                          <input class="form-control form-control-sm" placeholder="Search Asset No"
                                 [(ngModel)]="colSearch.assetNumber" 
                                 (keyup)="applyFilters()"
                                 [disabled]="isLoading">
                        </th>
                        <th>
                          <input class="form-control form-control-sm" placeholder="Search AssetDescription"
                                 [(ngModel)]="colSearch.AssetDescription" 
                                 (keyup)="applyFilters()"
                                 [disabled]="isLoading">
                        </th>
                        <th>
                          <input class="form-control form-control-sm" placeholder="Search Location"
                                 [(ngModel)]="colSearch.assetLocation" 
                                 (keyup)="applyFilters()"
                                 [disabled]="isLoading">
                        </th>
                        <th>
                          <input class="form-control form-control-sm" placeholder="Search Current Location"
                                 [(ngModel)]="colSearch.assetCurrentLocation" 
                                 (keyup)="applyFilters()"
                                 [disabled]="isLoading">
                        </th>
                        <th>
                          <input class="form-control form-control-sm" placeholder="Search Scan By"
                                 [(ngModel)]="colSearch.scanType" 
                                 (keyup)="applyFilters()"
                                 [disabled]="isLoading">
                        </th>
                         <th>
                          <input class="form-control form-control-sm" placeholder="Tag Id"
                                 [(ngModel)]="colSearch.scanned_value" 
                                 (keyup)="applyFilters()"
                                 [disabled]="isLoading">
                        </th>
                        <th>
                          <input class="form-control form-control-sm" placeholder="Search Status"
                                 [(ngModel)]="colSearch.status" 
                                 (keyup)="applyFilters()"
                                 [disabled]="isLoading">
                        </th>
                        <th>
                          <input class="form-control form-control-sm" placeholder="Search User"
                                 [(ngModel)]="colSearch.userName" 
                                 (keyup)="applyFilters()"
                                 [disabled]="isLoading">
                        </th>
                        <th>
                          <input class="form-control form-control-sm" placeholder="Search Reader Id"
                                 [(ngModel)]="colSearch.readerId" 
                                 (keyup)="applyFilters()"
                                 [disabled]="isLoading">
                        </th>
                        <th>
                          <input class="form-control form-control-sm" placeholder="Search Last Scan"
                                 [(ngModel)]="colSearch.lastScan" 
                                 (keyup)="applyFilters()"
                                 [disabled]="isLoading">
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      <!-- FIX: Changed from filteredReport to report -->
                      <tr *ngFor="let e of report; let i = index">
                        <td>{{ (currentPage - 1) * itemsPerPage + i + 1 }}</td>
                        <td>{{ e.assetNumber || "-" }}</td>
                        <th>{{e.AssetDescription || "-"}}</th>
                        <td>{{ e.assetLocation || "-" }}</td>
                        <td>{{ e.assetCurrentLocation || "-" }}</td>
                        <td>{{ e.scanType || "-" }}</td>
                       <td>{{ e.scanned_value || "-" }}</td>
                        <td>
                          <span [ngClass]="{
                              'text-success': e.status === 'Scanned',
                              'text-danger': e.status === 'Not Scanned',
                              'text-warning': e.status && e.status !== 'Scanned' && e.status !== 'Not Scanned'
                            }">
                            {{ e.status || "-" }}
                          </span>
                        </td>
                        <td>{{ e.userName || "-" }}</td>
                        <td>{{ e.readerId || "-" }}</td>
                        <td>{{ e.lastScan || "-" }}</td>
                      </tr>

                      <tr *ngIf="!report || report.length === 0">
                        <td colspan="9" class="text-center text-muted py-4">
                          <div *ngIf="isLoading">
                            <div class="spinner-border spinner-border-sm" role="status"></div>
                            Loading data...
                          </div>
                          <div *ngIf="!isLoading && (colSearch.assetNumber || colSearch.assetLocation || colSearch.status)">
                            <i class="fa fa-search fa-2x text-muted mb-2"></i><br>
                            No matching records found for your search.
                            <div class="mt-2">
                              <button class="btn btn-sm btn-outline-primary" (click)="clearColumnSearches()">
                                Clear Search
                              </button>
                            </div>
                          </div>
                          <div *ngIf="!isLoading && !colSearch.assetNumber && !colSearch.assetLocation && !colSearch.status">
                            No data available. Please apply filters and click Search.
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            
            <!-- 📌 FIXED PAGINATION BAR -->
            <div *ngIf="!isLoading && totalPages > 0"
              class="position-absolute bottom-0 start-0 end-0 d-flex justify-content-between align-items-center p-2 border-top"
              style="background-color: #f8f9fa; height: 60px">
              
              <!-- Left side: Page info -->
              <div class="text-muted">
                Showing {{getDisplayRange()}}
                <span *ngIf="colSearch.assetNumber || colSearch.assetLocation || colSearch.status" 
                      class="ms-2 badge bg-info">
                  Filtered
                </span>
              </div>
              
              <!-- Right side: Pagination controls -->
              <div class="d-flex align-items-center">
                <select class="form-select form-select-sm me-2 border-primary" style="width: 70px"
                  [(ngModel)]="itemsPerPage" (change)="changePageSize(itemsPerPage)" [disabled]="isLoading">
                  <option *ngFor="let size of pageSizeOptions" [value]="size">
                    {{ size }}
                  </option>
                </select>

                <select class="form-select form-select-sm me-2 border-primary" style="width: 100px"
                  [(ngModel)]="currentPage" (change)="goToPage(currentPage)" [disabled]="isLoading">
                  <option *ngFor="let i of [].constructor(totalPages); let page = index" [value]="page + 1">
                    Page {{ page + 1 }}
                  </option>
                </select>

                <button class="btn btn-primary btn-sm me-2" (click)="goToPage(currentPage)" [disabled]="isLoading">
                  Go
                </button>

                <button class="btn btn-primary btn-sm me-1" [disabled]="currentPage === 1 || isLoading" 
                  (click)="goToPage(1)">
                  &lt;&lt;
                </button>

                <button class="btn btn-primary btn-sm" [disabled]="currentPage === totalPages || isLoading" 
                  (click)="goToPage(totalPages)">
                  &gt;&gt;
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>